import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PageBase } from 't4core';
import { ServiceGuyInfo } from 't4core';
import { T4DatatableWidget } from '../../../../t4common';

@Component({
  styleUrls: ['./ServiceGuys.css'],
  selector: 'ServiceGuys',
  templateUrl: './ServiceGuys.component.html',
})
export class ServiceGuysComponent extends PageBase implements OnInit {

  @ViewChild("listOfGuys")
  private listOfGuys: T4DatatableWidget;

  constructor(el: ElementRef, private route: ActivatedRoute) {
      super(el, "Service");
    }

  async ngOnInit() { }

  public async createServiceGuy() {
    var newGuy = new ServiceGuyInfo();
    var ret = await this.UI.openDialog('T4.Service.ServiceGuyDialog', {
      data: { guy: newGuy },
      width: "1100px" });

    if (ret) {
      var token = this.UI.beginLoading("T4.Service.ServiceGuyDialog.ldrCreatingServiceGuy", "Creating service guy", null);
      var dbGuy = await this.Api.post<ServiceGuyInfo>('Service/CreateServiceGuy', newGuy);
      if (dbGuy) this.listOfGuys.data.data.push(dbGuy);

      this.UI.loaderCompleted(token);

      if (dbGuy) this.listOfGuys.update();
      
     }
  }

  public async deleteServiceGuy(x) {
    var newGuy = new ServiceGuyInfo();
    var ret = await this.UI.confirm('T4.Service.ServiceGuys.headConfirmDelete', 'Are you sure?', 'T4.Service.ServiceGuys.msgConfirmDelete', 'Are you sure you want to delete this service guy? This operation cannot be undone!');
    if (ret) {
      var token = this.UI.beginLoading("T4.Service.ServiceGuyDialog.ldrDeletingServiceGuy", "Deleting service guy", null);
      await this.Api.delete<ServiceGuyInfo>('Service/DeleteServiceGuy', { id: x.Id });

      this.listOfGuys.update();
      this.UI.loaderCompleted(token);
    }
  }

  public async showServiceGuy(x) {
    var ret = await this.UI.openDialog('T4.Service.ServiceGuyDialog', { data: { guy: x } });
      if (ret) {
        var token = this.UI.beginLoading("T4.Service.ServiceGuyDialog.ldrSavingServiceGuy", "Updating service guy", null);
        await this.Api.post<ServiceGuyInfo>('Service/UpdateServiceGuy', x);

        this.listOfGuys.update();
        this.UI.loaderCompleted(token);
      }
  }
}
